module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "g-bg-secondary g-pt-100 g-pb-50"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row g-mb-40"
  }, [(_vm.CheckLogin()) ? _c('div', {
    staticClass: "col-6 col-md-3 g-mb-20"
  }, [_c('b', {
    staticClass: "g-font-size-18"
  }, [_vm._v("Pages")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled g-mt-20"
  }, [_c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Home')
      }
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Order')
      }
    }
  }, [_vm._v("Order Now")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('OrderTracking')
      }
    }
  }, [_vm._v("Track Orders")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Frames')
      }
    }
  }, [_vm._v("Frames")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('Resources')
      }
    }
  }, [_vm._v("Resources")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-16",
    on: {
      "click": function($event) {
        return _vm.RouterRedirect('UserAccount')
      }
    }
  }, [_vm._v("My Account")])])])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.CheckLogin()) ? _c('div', {
    staticClass: "col-6 col-md-3 g-mb-20"
  }) : _vm._e(), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-4 col-lg-3 order-md-2 g-mb-30"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-lg-3 order-md-1 g-mb-30"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6 col-md-3 g-mb-20"
  }, [_c('b', {
    staticClass: "g-font-size-18"
  }, [_vm._v("Links and More")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled g-mt-20"
  }, [_c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "http://www.onesight.essilorluxottica.com"
    }
  }, [_vm._v("OneSight EssilorLuxottica Foundation")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "https://www.evfusa.org/terms-and-conditions"
    }
  }, [_vm._v("Terms of Use")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "http://www.evfusa.org/privacy-policy"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "http://www.evfusa.org/disclosures"
    }
  }, [_vm._v("Disclosures")])]), _vm._v(" "), _c('li', {
    staticClass: "g-py-5"
  }, [_c('a', {
    staticClass: "hover u-link-v5 g-color-footer-links g-color-primary--hover g-font-size-17",
    attrs: {
      "target": "_blank",
      "href": "https://www.essilorusa.com/about/ethics-compliance"
    }
  }, [_vm._v("Ethics & Compliance")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12 col-md-6 g-mb-20"
  }, [_c('img', {
    staticClass: "evf-watermark-2",
    attrs: {
      "src": "/static/assets/img/logo/OSEL Foundation_black_horizontal.png"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-inline mb-0 evf-social-2 g-my-10"
  }, [_c('li', {
    staticClass: "list-inline-item g-mx-2"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--sm u-shadow-v32 g-color-primary g-color-white--hover g-bg-white g-bg-primary--hover rounded-circle",
    attrs: {
      "href": "https://twitter.com/onesightorg"
    }
  }, [_c('i', {
    staticClass: "g-font-size-default fa fa-twitter"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item g-mx-2"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--sm u-shadow-v32 g-color-primary g-color-white--hover g-bg-white g-bg-primary--hover rounded-circle",
    attrs: {
      "href": "https://www.facebook.com/onesight/"
    }
  }, [_c('i', {
    staticClass: "g-font-size-default fa fa-facebook"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item g-mx-2"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--sm u-shadow-v32 g-color-primary g-color-white--hover g-bg-white g-bg-primary--hover rounded-circle",
    attrs: {
      "href": "https://www.linkedin.com/company/onesightessilorluxotticafoundation"
    }
  }, [_c('i', {
    staticClass: "g-font-size-default fa fa-linkedin"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-inline-item g-mx-2"
  }, [_c('a', {
    staticClass: "u-icon-v1 u-icon-size--sm u-shadow-v32 g-color-primary g-color-white--hover g-bg-white g-bg-primary--hover rounded-circle",
    attrs: {
      "href": "https://www.instagram.com/onesight/"
    }
  }, [_c('i', {
    staticClass: "g-font-size-default fa fa-instagram"
  })])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-01ca6d0e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01ca6d0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/FooterComponent.vue
// module id = 454
// module chunks = 3